import React from 'react'
import uid from 'utils/uid'
import { Flex, FlexItem } from 'core/layout'
import {
  Video,
  Waves,
  Wind,
  SortAlpha,
  Document,
  Contacts
} from 'core/icons'
import { Card, Hairline } from 'elements'
import tulkojumi from 'utils/tulkojumi'
import pathWithRewrite from 'utils/pathWithRewrite'
import { Section } from './styled'

class CardsSection extends React.PureComponent {
  render() {
    const { id, data, teksti, layout, onPopup } = this.props

    const mapIconById = id => {
      switch (id) {
        case 'video':
          return Video
        case 'waves':
          return Waves
        case 'wind':
          return Wind
        case 'sort-alpha':
          return SortAlpha
        case 'document':
          return Document
        case 'contacts':
          return Contacts
        default:
      }
    }

    const layoutProps = {
      compact: layout !== 'desktop'
    }

    // NOTE: Šis vajadzīgs komponenta izmantošanai
    // citā vidē, kur nebūs definēts šis konstants
    const publicUrl = process.env.PUBLIC_URL || ''

    const renderCard = (id, data, teksti) => {
      if (!data) {
        return null
      }

      const thumbnailProps = thumbnail => {
        const thumbnailProps = {}
        if (thumbnail && typeof thumbnail === 'object') {
          thumbnailProps.thumbnail = publicUrl + thumbnail.src
          if (thumbnail.align) {
            thumbnailProps.thumbnailAlign = thumbnail.align
          }
        } else if (typeof thumbnail === 'string') {
          thumbnailProps.thumbnail = publicUrl + thumbnail
        }
        return thumbnailProps
      }

      const videoPosterProps = video => {
        const videoProps = {
          video: {
            src: publicUrl + video.src,
            duration: video.duration
          }
        }
        if (typeof video.poster === 'object') {
          const { poster } = video
          videoProps.thumbnail = publicUrl + poster.src
          if (poster.align) {
            videoProps.thumbnailAlign = poster.align
          }
        } else if (typeof video.poster === 'string') {
          videoProps.thumbnail = publicUrl + video.poster
        }
        return videoProps
      }

      const rewrite = pathWithRewrite(data, {
        key: 'location'
      })
      const commonProps = Object.assign({},
        layoutProps,
        {
          title: data.title,
          link: rewrite.location,
          target: rewrite.target
        }
      )

      let galerijsPopup = false
      const galerijaQueryId = {}
      const galerijaIdent = data.post_type + data.template
      if (galerijaIdent === 'VideoDefault' || galerijaIdent === 'PageBilzuGalerija') {
        galerijsPopup = true
        galerijaQueryId['data-query-id'] = 'js-gallery-popop'
      }
      const popupHandler = galerijsPopup ? event => {
        event.preventDefault()
        const { onPopup } = this.props
        onPopup && onPopup(data.location)
      } : null

      switch (id) {
        case 'aktuali':
          return (
            <Card
              {...commonProps}
              subtitle={data.subtitle}
              actionLabel={data.actionLabel}
              {...thumbnailProps(data.thumbnail)}
              onClick={popupHandler} />
          )
        case 'parPilsetu':
          return (
            <Card
              type='cover'
              {...commonProps}
              {...thumbnailProps(data.thumbnail)}
              {...galerijaQueryId}
              onClick={popupHandler} />
          )
        case 'videoGalerija':
          return (
            <Card
              type='video'
              {...commonProps}
              {...videoPosterProps(data.video)}
              a11yLabel={tulkojumi(teksti, 'atskanot_video')}
              {...galerijaQueryId}
              onClick={popupHandler} />
          )
        case 'liepajniekiem':
        case 'uznemejiem':
          return (
            <Card
              {...commonProps}
              description={data.description}
              {...thumbnailProps(data.thumbnail)} />
          )
        case 'noderigi':
          return (
            <Card
              type='icon'
              {...commonProps}
              accent={data.accent}
              icon={mapIconById(data.icon)} />
          )
        default:
          return null
      }
    }

    return (
      <Section>
        <Hairline
          {...layoutProps}
          icon={mapIconById(data.icon)}
          title={data ? data.title : ''} />

        <Flex>
          {
            data.items.map(item => (
              <FlexItem key={uid()}>
                {renderCard(id, item, teksti)}
              </FlexItem>
            ))
          }
        </Flex>
      </Section>
    )
  }
}

export default CardsSection



// WEBPACK FOOTER //
// ./src/modules/CardsSection/CardsSection.jsx